/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".step-wrap[_ngcontent-%COMP%]{display:flex;gap:8px}.step-number[_ngcontent-%COMP%]{height:28px;width:28px;display:flex;align-items:center;justify-content:center;border-radius:50%;background:var(--button-background);opacity:.6;color:#fff;font-size:16px}.current-step[_ngcontent-%COMP%]   .step-number[_ngcontent-%COMP%]{opacity:1}\n/*# sourceMappingURL=wizard-step-title.component.css.map*/"];
export { styles as styles };
